// Spec 39. Drives PostHog identity off the auth session: identify on login
// (with the active org as group), re-group when the workspace switches, reset
// on logout. Lives inside the router so it can read useSession. Renders null.

import { useEffect, useRef } from "react";

import { analytics } from "@/lib/analytics";
import { useSession } from "@/lib/auth-client";

export function AnalyticsBridge() {
	const session = useSession();
	const user = session.data?.user;
	const activeOrgId =
		(session.data?.session as { activeOrganizationId?: string | null } | null)
			?.activeOrganizationId ?? null;

	// Track the last identified user/org so identify/reset/group fire only on
	// real transitions, not on every render.
	const identifiedId = useRef<string | null>(null);
	const groupedOrg = useRef<string | null>(null);

	useEffect(() => {
		if (user?.id) {
			if (identifiedId.current !== user.id) {
				analytics.identify(
					{ id: user.id, email: user.email, name: user.name },
					activeOrgId,
				);
				identifiedId.current = user.id;
				groupedOrg.current = activeOrgId;
			} else if (activeOrgId && activeOrgId !== groupedOrg.current) {
				analytics.group(activeOrgId);
				groupedOrg.current = activeOrgId;
			}
		} else if (identifiedId.current && !session.isPending) {
			analytics.reset();
			identifiedId.current = null;
			groupedOrg.current = null;
		}
	}, [user?.id, user?.email, user?.name, activeOrgId, session.isPending]);

	return null;
}
